import React from "react";
import BidTypeAboutLogo from "../../../assets/bidtypelogo1.png";
import "./BidTypeAbout.css";

const BidTypeAbout = () => {
  return (
    <div className="Bid-Type-About-container">
      <a href="https://bidtype.com/bid-type/frontend/" target="_blank" rel="noopener noreferrer">
        <div className="Bid-Type-About-logo">
          <img src={BidTypeAboutLogo} alt="BidTypeAbout Logo" />
        </div>
      </a>
      <div className="Bid-Type-About-content">
        <h1 className="Bid-Type-About-title">BidType.com</h1>
        <p className="Bid-Type-About-text">
          Enter BidType.com, a realm that transcends the ordinary digital
          marketplace, evolving into a harmonious convergence of technological
          prowess and automotive passion.
          <br />
          <br />
          Envision an arena where vehicular transactions transcend norms,
          transforming into a virtual theater where global automotive
          enthusiasts engage in a mesmerizing ballet of admiration and
          acquisition.
          <br />
          <br />
          Our innovative auction dynamics transcend mere features; they embody
          our unwavering commitment to redefining paradigms. Through
          cutting-edge listings, meticulously captured imagery, and intricate
          specifications, BidType.com metamorphoses information into the very
          currency of informed decision-making.
          <br />
          <br />
          This is where technology and automotive artistry dance in symphony,
          uniting enthusiasts within a realm where the narrative of vehicles is
          orchestrated with meticulous precision.
        </p>
      </div>
    </div>
  );
};

export default BidTypeAbout;
